import axios from "@/plugins/axios";
export default {
  async getSelectedGroupMembers(url, selectedGroupID) {
    const groupMembers = await axios.postDataWithToken(
      url,
      { selectedGroupID },
      localStorage.getItem("token")
    );
    return groupMembers;
  },
};
